import React from 'react';
import AsyncPage from './async';
import DefaultConsumerLayout from '../../../../components/layout/DefaultConsumerLayout';

export default [
  <DefaultConsumerLayout
    key="/consumer/features/cutout-images"
    exact
    path="/consumer/features/cutout-images"
    component={AsyncPage}
  />,
];
